export default {
  // Please use markdown syntax encapsulated in backticks - check the readme for more info
  markdown: ``,
}
